import { render } from "./LanguageDropdown.vue?vue&type=template&id=329efd16&scoped=true&ts=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts"

import "./LanguageDropdown.vue?vue&type=style&index=0&id=329efd16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329efd16"]])

export default __exports__